import { getSessionInstructor, getSessionTitle } from "@kvix/shared";
import { Box, makeStyles } from "@material-ui/core";
import { addDays, format, isToday, isWithinInterval } from "date-fns";
import { isTomorrow, subDays } from "date-fns/esm";
import { sv } from "date-fns/locale";
import i18next from "i18next";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "../../Primitives";
const useStyles = makeStyles((theme) => ({
    sessionInfo: {
        margin: "2px 0 3px",
        fontSize: "12px",
        fontWeight: 600,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        textOverflow: "ellipsis"
    },
    sessionTitle: {
        fontWeight: 700,
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontSize: "18px",
        lineHeight: "24px",
        maxHeight: "49px",
        [theme.breakpoints.down("xs")]: {
            fontSize: "16px",
            lineHeight: "21px",
            maxHeight: "43px"
        }
    },
    sessionUsername: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontWeight: 600,
        fontSize: "14px"
    },
    channelNumber: {
        background: theme.palette.secondary.main,
        color: theme.palette.common.white,
        padding: "0 2px 2px 3px",
        borderRadius: 3,
        fontWeight: 700
    },
    sessionWhen: {
        textTransform: "capitalize"
    }
}));
export const SessionInfo = ({ session, showChannel = true, hideDate = false }) => {
    var _a, _b, _c, _d;
    const classes = useStyles();
    const currentLanguage = i18next.language;
    const { start, end } = session;
    const now = new Date();
    const { t, ready } = useTranslation("general");
    const startDate = new Date(start);
    const endDate = new Date(end);
    const title = getSessionTitle(session);
    const instructor = getSessionInstructor(session);
    const displayWeekday = isWithinInterval(startDate, {
        start: subDays(now, 7),
        end: addDays(now, 7)
    });
    const when = useMemo(() => {
        const time = `${format(startDate, "HH:mm")} - ${format(endDate, "HH:mm")}`;
        const today = isToday(startDate);
        const tomorrow = isTomorrow(startDate);
        if (today) {
            return `${t("today")} ${time}`;
        }
        if (tomorrow) {
            return `${t("tomorrow")} ${time}`;
        }
        if (displayWeekday) {
            return `${format(startDate, "eeee", {
                locale: currentLanguage === "sv-SE" && sv
            })} ${time}`;
        }
        return `${format(startDate, "dd/LL", {
            locale: currentLanguage === "sv-SE" && sv
        })} ${time}`;
    }, [displayWeekday, startDate]);
    const name = ((_a = instructor === null || instructor === void 0 ? void 0 : instructor.name) === null || _a === void 0 ? void 0 : _a.custom) || `${(_b = instructor === null || instructor === void 0 ? void 0 : instructor.name) === null || _b === void 0 ? void 0 : _b.first} ${(_c = instructor === null || instructor === void 0 ? void 0 : instructor.name) === null || _c === void 0 ? void 0 : _c.last}`;
    if (!ready) {
        return null;
    }
    return (React.createElement(Box, { className: classes.sessionInfo },
        React.createElement("span", { className: classes.sessionWhen },
            showChannel && ((_d = session.channel) === null || _d === void 0 ? void 0 : _d.channelNumber) && (React.createElement("span", { className: classes.channelNumber }, `K${session.channel.channelNumber}`)),
            hideDate ? "" : when),
        React.createElement(Text, { className: classes.sessionTitle }, title),
        React.createElement(Text, { className: classes.sessionUsername }, name)));
};
//# sourceMappingURL=SessionInfo.js.map